<template>
    <basic-container>
      <el-form
        :model="searchForm"
        ref="searchFormRef"
        label-width="100px"
        label-suffix=":"
        v-show="searchBoxFlag"
      >
        <el-row :gutter="24">
          <el-col :span="6">
            <el-form-item label="服务网点" prop="nursinghomeId">
              <el-select
                v-model="searchForm.nursinghomeId"
                style="width:100%"
                placeholder="服务网点"
                @change="nursinghomeIdChange"
              >
                <el-option
                  v-for="item in nursinghomeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="服务类型" prop="serviceType">
              <el-select clearable v-model="searchForm.serviceType" style="width:100%" placeholder="服务类型">
                <el-option
                  v-for="item in typeDice"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
  
          
          <el-col :span="6">
            <el-form-item label="服务名称" prop="name">
              <el-input
                clearable
                v-model="searchForm.name"
                placeholder="服务名称"
                maxlength="100"
              ></el-input>
            </el-form-item>
          </el-col>
         
  
         
          <el-col :span="6">
            <div style="float:right">
              <el-button type="primary" icon="el-icon-search" @click="searchRecord" size="small">
                搜索
              </el-button>
              <el-button icon="el-icon-delete" @click="searchClear" size="small"> 清空 </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <avue-crud
        :option="option"
        :table-loading="loading"
        :data="data"
        :page.sync="page"
        ref="crud"
        @on-load="onLoad"
        @current-change="currentChange"
        @size-change="sizeChange"
        @refresh-change="onLoad"
        @selection-change="selectionChange"
      >
        <template slot="menuRight">
          <searchFromShow
            :searchBoxFlag.sync="searchBoxFlag"
            :removeHeight="searchHeight"
            :option="option"
            reduceHeight="20"
            :refOption="$refs.crud"
          ></searchFromShow>
        </template>
       
        <template slot="menuLeft">
          <el-button v-if="permission.serveItemManage_add" type="primary" size="small" @click="addNursingForm"> 新 增</el-button>
        
        </template>
        <template slot-scope="scope" slot="menu">
          <el-button v-if="permission.serveItemManage_edit" type="text" size="small" @click="editRecord(scope.row)">编辑 </el-button>
          
          <el-button v-if="permission.serveItemManage_delete" type="text" size="small" @click="deleteFun(scope.row.id)">删除 </el-button>


          <el-button v-if="permission.serveItemManage_serve" type="text" size="small" @click="openItemDetail(scope.row)">服务项目明细 </el-button>
        </template>
      </avue-crud>
     
    <itemList ref="itemList"></itemList>
    <hr-dialog
      :title="formTittle"
      :allowFull="false"
      width="60%"
      :visible.sync="nursingFormVisible"
    >
      <template slot="body">
        <serveForm
        :model="formModel"
        :row="formRow"
          @cancle="recordCancle"
          v-if="nursingFormVisible"
          
          @success="recordSuccess"
          :nursinghomeId="this.searchForm.nursinghomeId"
        ></serveForm>
      </template>
    </hr-dialog>
    </basic-container>
  </template>
  <script>
  import { getNursinghomeList } from '../api/public.js';
  import { serviceItemPage, getWarehouseList,serviceItemRemove } from '../api/serveItemManage.js';
  import itemList from './serveDetail.vue';
  import searchFromShow from '@/components/search-form-show/index';
  import { getDictionary } from '@/api/common.js';
  import { mapGetters } from 'vuex';
import serveForm from './serveForm.vue';
  export default {
    components: { searchFromShow ,itemList,serveForm},
    data() {
      return {
        editVisible:false,
        formModel:'add',
        isImportDialogShow: false,
        settingTotalWarnVisible: false,
        nursingFormVisible: false,
        printVisible: false,
        addOrderVisible: false,
        formVisible: false,
        formTittle: '编辑',
        formModel: 'view',
        rowInfo: {},
        searchForm: {
          nursinghomeId: '',
          warehouseId: '',
          type: '0',
          consumableCode: '',
          consumableName: '',
          specification: '',
          upWarnFlag: 'false',
          downWarnFlag: 'false',
        },
        typeDice: [
          
        ],
        nursinghomeList: [],
  
        option: {
          selection: false,
          select: true,
          index: true,
          indexLabel: '#',
          page: true,
          height: 'auto',
          calcHeight: 'auto',
          align: 'left',
          menu: true,
          addBtn: false,
          editBtn: false,
          delBtn: false,
          border: true,
          column: [
            {
              label: '服务网点',
              prop: 'nursinghomeId',
              type: 'string',
            dataType: 'number',
            props: {
              label: 'name',
              value: 'id',
            },
            dicUrl: '/api/nursing/getNursinghome',
            },
            {
              label: '服务类型',
              prop: 'serviceType',
              type: 'select',
            dataType: 'number',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dicUrl: '/api/blade-system/dict/dictionary?code=nursinghome_service_type',
            },
            {
              label: '服务名称',
              prop: 'name',
            },
            // {
            //   label: '价格',
            //   prop: 'price',
            // },
            {
              label: '排序',
              prop: 'sort',
            },
            // {
            //   label: '使用频次',
            //   prop: 'useFrequency',
            // },
            {
              label: '备注',
              prop: 'description',
            },
          ],
        },
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0,
        },
        loading: false,
        searchBoxFlag: true,
        searchHeight: '',
        selectionList: [],
        recordIds: [],
        canteenList: [],
        warehouseList: [],
        selectionIds: '',formRow:{}
      };
    },
    created() {
      
      this.initData();
    },
    computed: {
      ...mapGetters(['permission']),
    permissionList() {
      return {
        delBtn: this.vaildData(this.permission.serveItemManage_delete, false),
        editBtn: this.vaildData(this.permission.serveItemManage_edit, false),
        addBtn: this.vaildData(this.permission.serveItemManage_add, false),
        serveBtn: this.vaildData(this.permission.serveItemManage_serve, false),
      };
    },
    },
    mounted() {
      this.calcHeight();
      // 当窗口尺寸发生变化时，表格线会错乱，加上如下处理可解决此问题
      setTimeout(() => {
        window.onresize = () => {
          this.$nextTick(() => {
            this.$refs.crud.refreshTable();
          });
        };
      });
    },
    activated() {
      // 当从其它窗口切换回当前页面时，表格线会错乱，加上如下处理可解决此问题
      this.$nextTick(() => {
        this.$refs.crud.refreshTable();
      });
    },
    methods: {
        openItemDetail(row){
            this.$refs.itemList.openItemListOnload(row.id,row.name);
        },
        addNursingForm(){
          this.formModel ="add"
          this.formTittle= "新增"
          this.nursingFormVisible = true  
        },
      importSuccess(){
        this.isImportDialogShow = false
        this.onLoad()
      },
    
      deleteFun(id){
        this.$confirm(' 是否删除该数据?', '提示', {
             confirmButtonText: '确定',
             cancelButtonText: '取消',
             type: 'warning'
           }).then(() => {
            serviceItemRemove(id).then(re=>{
              this.$message.success('删除成功');
              this.onLoad()
            })
           
           }).catch(() => {
             this.$message({
               type: 'info',
               message: '已取消操作'
             });          
           });
       
      },

      editRecord(row){
        this.formRow = row
        this.formTittle="编辑"
        this.formModel = "edit"
        this.nursingFormVisible = true;
      },
      settingTotalWarn() {
        this.formModel='add'
        this.settingTotalWarnVisible = true;
      },
      importFun() {
       
        this.isImportDialogShow = true;
      },
      nursingForm() {
        this.formModel='add'
        this.nursingFormVisible = true;
      },
     
      recordCancle() {
        this.editVisible = false
        this.nursingFormVisible = false;
        this.settingTotalWarnVisible = false;
      },
      recordSuccess() {
        this.editVisible = false
        this.nursingFormVisible = false;
        this.settingTotalWarnVisible = false;
        this.onLoad();
      },
      viewRecord(row) {
        this.formTittle = '查看';
        this.rowInfo = row;
  
        this.formModel = 'view';
        this.formVisible = true;
      },
  
      addRecord() {
        this.formTittle = '新增';
        this.formVisible = true;
        this.rowInfo = {
          nursinghomeId: this.searchForm.nursinghomeId,
        };
        this.formModel = 'add';
      },
     
      stopCanteen() {
        this.formVisible = true;
      },
      nursinghomeIdChange(nursinghomeId) {
      
        this.searchForm.warehouseId =''
        this.warehouseList = [];
        getWarehouseList({ nursinghomeId: this.searchForm.nursinghomeId }).then((res) => {
              this.warehouseList = res.data;
            });
        // //  getCanteenName({nursinghomeId:nursinghomeId}).then(res=>{
        // //           this.canteenList = res.data
        // //        })
        // this.getDeptList(this.searchForm.nursinghomeId);
        // this.getCanteen(this.searchForm.nursinghomeId);
      },
      searchRecord() {
        this.page.currentPage = 1;
        if(this.searchForm.upWarnFlag==""){
          this.searchForm.upWarnFlag = false
        }
        if(this.searchForm.downWarnFlag==""){
          this.searchForm.downWarnFlag = false
        }
        this.onLoad();
      },
      searchClear() {
        this.tool.clearObject(this.searchForm, 'nursinghomeId');
        this.searchForm.type='0'
      },
  
      calcHeight() {
        this.searchHeight = this.$refs.searchFormRef.$el.clientHeight;
        this.option.height = this.bodyHeight - this.searchHeight - 279 - 20;
      },
      initData() {
        getDictionary('nursinghome_service_type').then((res) => {
            this.typeDice = res.data;
          });
        getNursinghomeList().then((res) => {
          
          this.nursinghomeList = res.data;
          if (this.nursinghomeList.length > 0) {
            this.$set(this.searchForm, 'nursinghomeId', this.nursinghomeList[0].id);
           
            this.onLoad();
          }
        });
        // getDictionary('canteen_order_status').then((res) => {
        //   this.orderStatus = res.data;
        // });
      },
  
      onLoad() {
        if (this.searchForm.nursinghomeId != '') {
          this.loading = true;
  
          serviceItemPage(
            Object.assign(
              {},
              { current: this.page.currentPage, size: this.page.pageSize },
              this.searchForm
            )
          )
            .then(({ data }) => {
              this.data = data.records;
              this.page.total = data.total;
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });
        }
      },
    },
  };
  </script>
  
  <style scoped>
  ::v-deep .avue-crud__right {
    display: flex;
  }
  /deep/ .el-drawer__body {
    overflow: scroll !important;
  }
  ::v-deep .avue-crud .el-form-item {
    display: block;
  }
  
  .money {
    text-align: right;
  }
  .txtOver {
    display: -webkit-box;
    overflow: hidden; /*超出隐藏*/
    text-overflow: ellipsis; /*隐藏后添加省略号*/
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  </style>
  <style>
  #form > div > div.el-dialog__body {
    height: calc(100% - 100px);
  }
  </style>
  